import React, { useEffect, useState } from "react";
import { SliderReusableComponent } from "../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import {
  BackLogoIconButton,
  LoginTopLogoAndText,
} from "../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { Container, Col, Row } from "react-bootstrap";
import OtpInput from "react-otp-input";
import moment from "moment";
import { ButtonReusableComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";

// import { Button } from "@material-ui/core";
import { Dialog } from "@material-ui/core";
import { DialogActions } from "@material-ui/core";
import { DialogContent } from "@material-ui/core";
import { DialogContentText } from "@material-ui/core";
import { DialogTitle } from "@material-ui/core";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { admin_login, admin_otp } from "../../../store/actions/authAction";
import { setAuthenticationToken } from "../../../api/apiHelper";
import SocketContext from "../../../function/SocketContext";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import isEmpty from "../../../store/validation/is-Empty";

function AdminOtpComponentScreen(props) {
  const [otp, setState] = useState("");
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth : "";
  });

  const [otpError, setOtpError] = useState(false);

  const handleChange = (otp) => setState(otp);

  const [open, setOpen] = useState(false);

  const resendOtp = () => {
    let userId = location.state.userId;
    dispatch(admin_otp(userId, () => { }));
  };

  const onCallBack = (data) => {
    props.socket.authentication.setAccessToken(data).then((res) => {
      setAuthenticationToken(data);
      props.socket.authentication
        .reAuthenticate()
        .then((r) => {
          console.log("respose", r);
        })
        .catch((e) => {
          console.log("error", e);
        });
    }).catch(err => console.log('err :>> ', err));


    history.push("/superadmindashboard");
    // this.props.socket
    //   .service("vendorauthentication")
    //   .create({
    //     mobile_number: data.mobile_number,
    //     password: data.password,
    //     strategy: data.strategy,
    //   })
    //   .then(function (result) {
    //     const feathersToken = result;
    //     // SET Data to Local Storage
    //     localStorage.setItem("feathersToken", JSON.stringify(feathersToken));
    //   })
    //   .catch(function (error) {
    //     console.error("Error authenticating!", error);
    //   });
  };

  const adminLogin = () => {
    let userId = location.state.userId;
    dispatch(admin_login({ userId, otp }, (e) => onCallBack(e)));
  };

  if (auth.loader) {
    return (
      <>
        {" "}
        <AmealioLoader />{" "}
      </>
    );
  } else {
    return (
      <div>
        <React.Fragment>
          <Container fluid className="loginsignup-main">
            <Row>
              <Col className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 loginsignup-leftside">
                <div className="col-12 display-top-header-mobile display-in-mobile">
                  <BackLogoIconButton
                    workWithLinkORClick={true}
                    displayHelpImage={true}
                    notDisplaProgressBar={true}
                  />
                </div>
                <div className="col-12 loginsignup-section">
                  <LoginTopLogoAndText
                    bigText="2-Step Verification"
                    smallText={
                      <>
                        * A text message with a 6-digit verification code
                        <br /> was just sent to your registered phone number
                        <br />
                        It is valid for 10 minutes.
                      </>
                    }
                    linkTextBig="Not having an account?"
                    linkSmall="Sign Up"
                    redirectLink="/signup"
                  />
                </div>
                <div className="col-12 loginsignup-section">
                  <OtpInput
                    value={otp}
                    onChange={handleChange}
                    numInputs={6}
                    separator={<span>&nbsp;&nbsp; </span>}
                    inputStyle={{ width: "50px", height: "50px" }}
                    focusStyle={{ border: "2px solid #f85032" }}
                  />
                  {otpError && (
                    <div className="text-danger mt-1">
                      *The OTP you entered is invalid. Please enter the correct
                      OTP.
                    </div>
                  )}
                </div>
                <div className="col-12 login-bottom-text-blue mt-4">
                  {/* {"00:00"} &nbsp; |&nbsp;{" "} */}
                  <span className="text-primary cursor" onClick={resendOtp}>
                    Resend OTP
                  </span>
                </div>
                <Col className="login-section-margin mt-4">
                  <ButtonReusableComponent
                    buttonText="Login"
                    buttonType="Submit"
                    buttonClass={"activeLogin"}
                    onClick={adminLogin}
                  />
                </Col>
              </Col>
              <Col className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                <SliderReusableComponent
                  paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  bottomImage={
                    require("../../../assets/images/illustratorImage/Amealio_Illustrations-09.png")
                      .default
                  }
                />
              </Col>
            </Row>
          </Container>

          {/* <ParticlesBg color="#636466" num={175} type="cobweb" bg={true} /> */}
        </React.Fragment>
      </div>
    );
  }
}

const AdminOtpComponent = (props) => (
  <SocketContext.Consumer>
    {(socket) => <AdminOtpComponentScreen {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default AdminOtpComponent;
